import { useState } from "react";
import { MdDelete } from "react-icons/md";
import Input from "../../../Input/Input";
import "./AddPaymentProcessSection.scss";

const initialState = [
  "Account_Number",
  "Account_Type",
  "Bank_Name",
  "Bank_IFSC_Code",
  "Party_Name",
  "Reference_No",
  "Amount",
  "TypeOfPayment",
  "Date",
  "Narration",
  "Remarks",
  "Delete",
];
function PaymentProcessTable({
  formik,
  name,
  handleRowDelete,
  onTransactionChange,
  el,
  dropDownData,
  tablerow,
  onPaymentChange,
  handlePaymentDelete,
}) {
  const [coloums, setColumns] = useState(initialState);

  return (
    <>
      <tr className="" key={el.id}>
        {coloums?.map((e, i) => {
          if (e === "Delete") {
            return (
              <td>
                <MdDelete onClick={() => handlePaymentDelete(el._id)} />
              </td>
            );
          }
          if (e === "TypeOfPayment") {
            return (
              <td className="paymentType">
                {" "}
                <Input
                 EMTQuery=""
                  checked={""}
                  InputConfig={e}
                  modalform={true}
                  dropdowndata={["IFT", "NEFT", "IMPS", "RTGS"]}
                  handleBlur={() => { }}
                  handleInputChange={(evt) => {
                    onPaymentChange(evt, el._id, "TypeOfPayment");
                  }}
                  label={``}
                  type="inputdrop"
                  name=""
                  PaymentProcess={true}
                  value={el["TypeOfPayment"] ? el["TypeOfPayment"] : ""}
                />
              </td>
            );
          }
          if (e === "Remarks") {
            return (
              <td className="paymentType">
                {" "}
                <Input
                 EMTQuery=""
                  checked={""}
                  InputConfig={e}
                  modalform={true}
                  handleBlur={() => { }}
                  handleInputChange={(evt) => {
                    onPaymentChange(evt, el._id, "Remarks");
                  }}
                  label={``}
                  type="text"
                  name=""
                  PaymentProcess={true}
                  value={el["Remarks"] ? el["Remarks"] : ""}
                />
              </td>
            );
          }
          return <td className="paymentProcessRow">{el[e]}</td>;
        })}
      </tr>
      <></>
    </>
  );
}

export default PaymentProcessTable;
